import { useIntl } from 'react-intl';

import Footer from '@/components/footer/FooterWrapper';
import GiftLayout from '@/components/gift/GiftLayout';
import giftMessages from '@/components/gift/Hero/messages';
import Layout from '@/components/layout/LayoutWrapper';
import { InitRequest, useInitState } from '@/hooks/store';
import messages from '@/messages/messages';
import getUrl from '@/utils/getUrl';

const GiftPage = () => {
	useInitState({
		requests: [InitRequest.PRICES, InitRequest.DEVICE],
	});
	const { formatMessage } = useIntl();

	return (
		<Layout
			pageName="calm_box"
			customSeo={{
				title: formatMessage(giftMessages.heading),
				primaryDescription: formatMessage(giftMessages.description),
				description: formatMessage(giftMessages.description),
				url: `${getUrl('www')}/gift`,
				imageUrl: `${getUrl('www')}/_n/images/social/gift-social.jpg`,
			}}
			title={`Calm - ${formatMessage(messages.giftCardPageTitle)}`}
		>
			<GiftLayout />
			<Footer />
		</Layout>
	);
};

export default GiftPage;
